/**
 * @generated SignedSource<<4db5da90265e08e605df0ee317ea064f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SurveyDetailsHeaderInfoQuery$variables = {
  surveyEntityId: string;
};
export type SurveyDetailsHeaderInfoQueryVariables = SurveyDetailsHeaderInfoQuery$variables;
export type SurveyDetailsHeaderInfoQuery$data = {
  readonly viewer: {
    readonly survey: {
      readonly id: string;
      readonly details: string | null;
    } | null;
  } | null;
};
export type SurveyDetailsHeaderInfoQueryResponse = SurveyDetailsHeaderInfoQuery$data;
export type SurveyDetailsHeaderInfoQuery = {
  variables: SurveyDetailsHeaderInfoQueryVariables;
  response: SurveyDetailsHeaderInfoQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "surveyEntityId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": "survey",
  "args": [
    {
      "kind": "Variable",
      "name": "surveyId",
      "variableName": "surveyEntityId"
    }
  ],
  "concreteType": "ViewerSurvey",
  "kind": "LinkedField",
  "name": "findSurvey",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SurveyDetailsHeaderInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SurveyDetailsHeaderInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89f6cc194633d8762c52dd421878e153",
    "id": null,
    "metadata": {},
    "name": "SurveyDetailsHeaderInfoQuery",
    "operationKind": "query",
    "text": "query SurveyDetailsHeaderInfoQuery(\n  $surveyEntityId: String!\n) {\n  viewer {\n    survey: findSurvey(surveyId: $surveyEntityId) {\n      id\n      details\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "efeed35539e6bc2f530275d08eeb9963";

export default node;
